/* global dataLayer */

import { useTranslation } from "react-i18next";
import SummaryCalculator from './summarycalculator';

export default class GTMHelper {
	pushToGTMDataLayer	= (data) =>{
		try {
	      window.dataLayer.push(data);
	    } catch (err) {
	      console.log('Error: dataLayer is not found in pushToGTMDataLayer().', data)
	    }
	}
    setGTM(data, isSimple, showPrevious) {
		// UNIT TEST CASE : Don't run the GTM.
		if(!window.summaryCalculator)
			return;

		const summaryCalculator = window.summaryCalculator;
		const selectedVehicle = summaryCalculator.selectedVehicle;
		const steps = [
			'vehicles',
			'trim',
			'options',
			'colour',
			'wheels',
			'connectivity',
			'accessories',
			'protections',
			'payments',
			'summary'
		]
		const GTMData = data;

		GTMData.step = GTMData.action === 'Next Step' ? steps[summaryCalculator.CurrentStep+1] : steps[summaryCalculator.CurrentStep];
		if(GTMData.action === 'Step'){
			GTMData.event = 'BnP - Step ' + GTMData.step;
		} else {
			GTMData.event = 'BnP - ' + GTMData.action;
		}
		if(showPrevious) GTMData.previous = steps[summaryCalculator.PreviousStep]
		if(!isSimple){
			GTMData.model = selectedVehicle.model;
			GTMData.trim = selectedVehicle.trim;
			GTMData.model = selectedVehicle.carline;
			GTMData.engine = selectedVehicle.model;
			GTMData.year = selectedVehicle.year;
			GTMData.interior = summaryCalculator._selectedColourInterior?.code !== undefined ? summaryCalculator._selectedColourInterior?.code : '';
			GTMData.exterior = summaryCalculator._selectedColourExterior?.code !== undefined ? summaryCalculator._selectedColourExterior?.code : '';
			GTMData.wheel = summaryCalculator._selectedWheel?.title !== undefined ? summaryCalculator._selectedWheel?.title : '';
			if(steps[summaryCalculator.PreviousStep] === 'wheels' && GTMData.wheel === '')  GTMData.wheel = 'No Selection';
			GTMData.accessories = summaryCalculator._selectedAccessories.length > 0 ? summaryCalculator._selectedAccessories.map(({ name }) => name) : '';
			if(summaryCalculator.FinancialInfo) GTMData.price = summaryCalculator.FinancialInfo.calculatedCash.subtotal;
		}
		delete GTMData.action;
		this.pushToGTMDataLayer(GTMData)
    }

}